import { useTranslation } from 'react-i18next';
import './Legislation.css'

const PrivacyLegislation = () => {
  const { t } = useTranslation()
  const sections = [
    {
      title: t("privacy-policy:section-1.title"),
      paragraphs: [t("privacy-policy:section-1.body")]
    },
    {
      title: t("privacy-policy:section-2.title"),
      intro: t("privacy-policy:section-2.intro"),
      list: [
        t("privacy-policy:section-2.item-1"),
        t("privacy-policy:section-2.item-2"),
        t("privacy-policy:section-2.item-3"),
        t("privacy-policy:section-2.item-4"),
        t("privacy-policy:section-2.item-5")
      ]
    },
    {
      title: t("privacy-policy:section-3.title"),
      intro: t("privacy-policy:section-3.intro"),
      list: [
        t("privacy-policy:section-3.item-1"),
        t("privacy-policy:section-3.item-2"),
        t("privacy-policy:section-3.item-3"),
        t("privacy-policy:section-3.item-4"),
        t("privacy-policy:section-3.item-5")
      ]
    },
    {
      title: t("privacy-policy:section-4.title"),
      intro: t("privacy-policy:section-4.intro"),
      list: [
        t("privacy-policy:section-4.item-1"),
        t("privacy-policy:section-4.item-2"),
        t("privacy-policy:section-4.item-3"),
        t("privacy-policy:section-4.item-4")
      ],
      // paragraphs: [t("privacy-policy:section-4.body")]
    },
    {
      title: t("privacy-policy:section-5.title"),
      paragraphs: [t("privacy-policy:section-5.body")]
    },
    {
      title: t("privacy-policy:section-6.title"),
      paragraphs: [t("privacy-policy:section-6.body")]
    },
    {
      title: t("privacy-policy:section-7.title"),
      intro: t("privacy-policy:section-7.intro"),
      list: [
        t("privacy-policy:section-7.item-1"),
        t("privacy-policy:section-7.item-2"),
        t("privacy-policy:section-7.item-3"),
        t("privacy-policy:section-7.item-4")
      ]
    },
    {
      title: t("privacy-policy:section-8.title"),
      paragraphs: [t("privacy-policy:section-8.body")]
    },
    {
      title: t("privacy-policy:section-9.title"),
      paragraphs: [t("privacy-policy:section-9.body")]
    },
    {
      title: t("privacy-policy:section-10.title"),
      paragraphs: [t("privacy-policy:section-10.body")]
    }
  ];

  return (
    <>
      <div className="details-overlay overlay-1">
        <p className="title-text">
          {t("landing:footer.privacy")}
        </p>
      </div>
      <div className="min-h-screen bg-gradient-to-b to-white p-8 legislation-page-wrap">
        <div className="mx-auto legislation-content-wrap">
          <div className="mt-3">
            <div className="custom-accordion-item p-4">
              <p className="fs-16 mb-4">
                <strong>{t("privacy-policy:effective-date-title")}</strong> {t("privacy-policy:effective-date")}
              </p>

              {sections.map((section, index) => (
                <div key={section.title} className="mb-4">
                  <h5 className="mb-2">{`${index + 1}. ${section.title}`}</h5>
                  {section.intro ? <p className="fs-16 mb-2">{section.intro}</p> : null}
                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph} className="fs-16 mb-2">{paragraph}</p>
                  ))}
                  {section.list ? (
                    <ul className="list-disc ml-6">
                      {section.list.map((item) => (
                        <li key={item} className="fs-16 mb-1">{item}</li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyLegislation;